"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var use_dialog_1 = require("hooks/use-dialog");
var Breadcrumb_1 = __importDefault(require("components/common/navigation/Breadcrumb"));
var Notification_1 = require("components/Notification");
var Dialog_1 = require("components/Dialog");
var EditProductOptionBasic_1 = __importDefault(require("./EditProductOptionBasic"));
var EditProductOptionItems_1 = __importDefault(require("./EditProductOptionItems"));
var TableHeading_1 = require("../../../common/table/TableHeading");
var apiRoutes = config_1.default.apiRoutes;
var EditProductOption = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), productOption = _a[0], setProductOption = _a[1];
    var _b = react_1.useState(null), editing = _b[0], setEditing = _b[1];
    var _c = use_stores_1.useStores(), apiStore = _c.apiStore, productOptionsStore = _c.productOptionsStore, productsStore = _c.productsStore, prefsStore = _c.prefsStore, productPageStore = _c.productPageStore;
    var prefs = prefsStore.data.productsTable;
    var busyRoutes = apiStore.data.busyRoutes;
    var params = react_router_dom_1.useParams();
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    react_1.useEffect(function () {
        if (productOptionsStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_OPTIONS)) {
            api_1.default.getProductOptions()
                .then(function (response) { return productOptionsStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
        if (productsStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCTS + ("?page=" + prefsStore.data.productsTable.page + "&limit=" + prefsStore.data.productsTable.perPage + "&sort=" + ((prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id')) + "&search=" + prefsStore.data.productsTable.search))) {
            api_1.default.getProducts(prefsStore.data.productsTable.page, prefsStore.data.productsTable.perPage, (prefsStore.data.productsTable.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefsStore.data.productsTable.sort.name !== null ? prefsStore.data.productsTable.sort.name : 'id'), prefsStore.data.productsTable.search)
                .then(function (response) {
                productsStore.setData(response.data.products);
                productPageStore.setData(response.data.page);
            })
                .catch(api_1.catchHandler);
        }
        document.addEventListener('click', clickHandler);
        return function () { return document.removeEventListener('click', clickHandler); };
    }, []);
    react_1.useEffect(function () {
        for (var _i = 0, _a = productOptionsStore.data; _i < _a.length; _i++) {
            var storeSpec = _a[_i];
            if (storeSpec.id === parseInt(params.id)) {
                setProductOption(storeSpec);
            }
        }
    }, [params.id, productOptionsStore.data]);
    var clickHandler = function (e) {
        var target = e.target;
        if (target.closest('.edit-product-spec-items'))
            return;
        setEditing(null);
    };
    var changeHandler = function (name, value) {
        var _a;
        api_1.default.editProductOption(__assign(__assign({}, productOption), (_a = {}, _a[name] = value, _a)))
            .then(function (response) {
            api_1.default.getProductOptions()
                .then(function (response) { return productOptionsStore.setData(response.data); })
                .catch(api_1.catchHandler);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Product option has been saved'
            });
        })
            .catch(api_1.catchHandler);
    };
    var editItemHandler = function (data) {
        api_1.default.editProductOptionItem(__assign({ id: editing }, data))
            .then(function (response) {
            api_1.default.getProductOptions()
                .then(function (response) { return productOptionsStore.setData(response.data); })
                .catch(api_1.catchHandler);
            setEditing(null);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Product option has been saved'
            });
        })
            .catch(api_1.catchHandler);
    };
    var deleteItemHandler = function (productOptionItem) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(productOptionItem.count > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dialog({
                            variant: Dialog_1.DialogVariants.ALERT,
                            title: "Cannot delete " + productOptionItem.name,
                            description: 'There are still products using this option item. Please remove this option item from those products before deleting it.'
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    dialog({
                        variant: Dialog_1.DialogVariants.CONFIRMATION,
                        title: "Delete " + productOptionItem.name + "?",
                        description: 'Are you sure you want to delete this item?'
                    })
                        .then(function () {
                        api_1.default.deleteProductOptionItem(productOptionItem)
                            .then(function () {
                            productOptionsStore.editDataItem(__assign(__assign({}, productOption), { productSpecificationItems: productOption.productOptionItems.filter(function (specItem) {
                                    return specItem.id !== productOptionItem.id;
                                }) }));
                            notification({
                                variant: Notification_1.NotificationVariants.SUCCESS,
                                message: 'Option item has been deleted'
                            });
                        })
                            .catch(api_1.catchHandler);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var submitHandler = function (name) {
        api_1.default.createProductOptionItem({
            productOptionId: productOption.id,
            name: name
        })
            .then(function (response) {
            productOptionsStore.editDataItem(__assign(__assign({}, productOption), { productOptionItems: __spreadArrays(productOption.productOptionItems, [
                    response.data
                ]) }));
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Option item has been added'
            });
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'page edit-product-specification' },
        react_1.default.createElement(Breadcrumb_1.default, { items: [
                { text: 'Products', href: '/products' },
                { text: 'Product Options', href: '/products/options' },
                { text: productOption.name, href: "/products/options/" + productOption.id },
            ] }),
        react_1.default.createElement(EditProductOptionBasic_1.default, { productOption: productOption, onChange: changeHandler }),
        react_1.default.createElement(EditProductOptionItems_1.default, { items: productOption.productOptionItems || [], editing: editing, onSetEdit: function (id) { return setEditing(id); }, onEdit: editItemHandler, onDelete: deleteItemHandler, onSubmit: submitHandler, products: productsStore.data })));
});
exports.default = EditProductOption;
